var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown (2) 1",
    clipPath: "url(#clip0_2901_1028019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6518 17.3426H4.34711C4.11328 17.3426 3.89484 17.2271 3.76318 17.0339C1.7439 14.0727 1.58899 8.37646 1.57727 7.53088C1.57654 7.49774 1.57617 7.46423 1.57617 7.43091C1.57617 7.04108 1.89185 6.72485 2.28168 6.72412H2.28314C2.67224 6.72412 2.98846 7.03888 2.98993 7.42816C2.98993 7.43292 2.99011 7.47467 2.99176 7.54865C3.05402 9.55969 4.70947 11.1763 6.73535 11.1763C8.8006 11.1763 10.4808 9.49615 10.4808 7.43091C10.4808 7.04053 10.7974 6.72412 11.1876 6.72412H12.8112C13.2015 6.72412 13.5179 7.04053 13.5179 7.43091C13.5179 9.49615 15.1983 11.1763 17.2635 11.1763C19.2913 11.1763 20.9478 9.55676 21.0073 7.54315C21.0086 7.47247 21.009 7.43292 21.009 7.42834C21.0104 7.03888 21.3265 6.72412 21.7158 6.72412H21.717C22.1069 6.72485 22.4225 7.04108 22.4225 7.43091C22.4225 7.46442 22.4222 7.49774 22.4216 7.53107C22.4097 8.37646 22.2548 14.0729 20.2357 17.0341C20.1041 17.2271 19.8854 17.3426 19.6518 17.3426Z",
    fill: "#FFF780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7174 6.72412C21.717 6.72412 21.7167 6.72412 21.7161 6.72412C21.327 6.72412 21.0108 7.03888 21.0093 7.42816C21.0093 7.43292 21.0092 7.47247 21.0077 7.54315C20.9482 9.55658 19.2916 11.1763 17.2639 11.1763C15.1987 11.1763 13.5185 9.49615 13.5185 7.43091C13.5185 7.04053 13.2019 6.72412 12.8117 6.72412H12V17.3424H19.6522C19.886 17.3424 20.1044 17.2269 20.2361 17.0339C22.2554 14.0727 22.4103 8.37628 22.422 7.53088C22.4227 7.49774 22.4231 7.46423 22.4231 7.43091C22.4229 7.04108 22.1072 6.72485 21.7174 6.72412Z",
    fill: "#FFC02E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9985 4.3125C10.7393 4.3125 9.71484 5.33698 9.71484 6.59619C9.71484 7.85541 10.7393 8.8797 11.9985 8.8797C13.2578 8.8797 14.2822 7.85541 14.2822 6.59619C14.2822 5.33698 13.2578 4.3125 11.9985 4.3125Z",
    fill: "#FFC02E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 4.3125V8.87988C13.2592 8.8797 14.2835 7.85541 14.2835 6.59619C14.2835 5.33698 13.259 4.31268 12 4.3125Z",
    fill: "#FFA73B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.28369 6.07471C1.02448 6.07471 0 7.09918 0 8.3584C0 9.61761 1.02448 10.6421 2.28369 10.6421C3.54291 10.6421 4.5672 9.61761 4.5672 8.3584C4.5672 7.09918 3.54291 6.07471 2.28369 6.07471Z",
    fill: "#FFC02E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.7151 6.07471C20.4559 6.07471 19.4316 7.09918 19.4316 8.3584C19.4316 9.61743 20.4559 10.6419 21.7151 10.6419C22.9744 10.6419 23.9988 9.61743 23.9988 8.3584C23.9988 7.09918 22.9744 6.07471 21.7151 6.07471Z",
    fill: "#FFA73B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.6521 19.6612H4.34741C3.95703 19.6612 3.64062 19.3448 3.64062 18.9544V16.8467H20.3589V18.9544C20.3589 19.3448 20.0425 19.6612 19.6521 19.6612Z",
    fill: "#FFC02E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12 19.6612H19.6522C20.0425 19.6612 20.3589 19.3448 20.3589 18.9544V16.8467H12V19.6612Z",
    fill: "#FFA73B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2901_1028019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.0e0cf37f7c7c3920588cea586f7eaac5.svg";
export { ForwardRef as ReactComponent };